import React, { useState, Fragment, useEffect } from "react";
import { Table, Image, Col, Modal } from "react-bootstrap";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Menu,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
import { withRouter, useHistory } from "react-router-dom";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Button } from "react-bootstrap";
import SelectFilter from "../../../../reusableComponents/selectFilter";
import { RightSideCountTop } from "../../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import moment from "moment";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import CSVDownloader from "../../../../reusableComponents/csvDownload/csvDownload";
import Alert from "react-s-alert";

// Animations

import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
import {
  getBusinessTimingsStatus,
  isInOperationalHours,
  statuses,
} from "../../../../reusableComponents/BusinessTimingsStatus";
import { get_all_admin_active_vendors } from "../../../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";
import BasicPagination from "../../../../Pagination/Pagination";
import isEmpty from "../../../../../store/validation/is-Empty";
import SessionSettingsAdminReports from "./SessionSettingsAdminReports";
import NoContent from "../../../../reusableComponents/NoContentComponent";

const zoomAnimation = keyframes`${zoomIn}`;

const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

// End Animations

const SuperAdminPromotionalVideos = (props) => {
  const history = useHistory();

  const [dateQuery, setDateQuery] = useState({
    startDate: moment(new Date("1999-01-01")).format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });

  useEffect(() => {
    getData(dateQuery);
  }, []);

  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };

  const getData = (date_query) => {
    const token = props.auth.user.accessToken;

    props.get_all_admin_active_vendors(
      token,
      true,
      dateQuery?.startDate,
      dateQuery?.endDate
    );
  };

  const [state, setState] = useState({
    search: "",
    restaurant_type: "",
    request_type: "All",
    showSearch: false,
    locationSearch: "",
    statusFilter: "",
  });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [showFilter, setShowFilter] = useState(false);

  const handleShowFilter = () => {
    setShowFilter(!showFilter);
  };

  const onSearchChange = (e) => {
    setState({
      ...state,
      search: e.target.value,
    });
  };
  const searchClick = () => {
    setShowFilter(!showFilter);
  };
  const cancelClick = () => {
    setShowFilter(!showFilter);
  };

  const [finalData, setFinalData] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    start: 0,
    end: 10,
    total: 0,
  });
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setPagination({ start: calcStart, end: pageNo * 10, page: pageNo });
  };
  let count = 0;
  let [stats, setStat] = useState({
    closed: 0,
    partially: 0,
    fully: 0,
    total: 0,
  });
  const [sort, setSort] = useState("");

  const downloadData = {
    headers: [
      { label: "Business Id", key: "bid" },
      { label: "Business Name", key: "bname" },
      { label: "status", key: "statusonline" },
      { label: "POC name", key: "contact" },
      { label: "Mobile number", key: "pocnumber" },
      { label: "Email Id", key: "pocemail" },
      { label: "Address", key: "address" },
      { label: "Restaurant Type", key: "restype" },
      { label: "Last Updated", key: "updatedAt" },
    ],
    data: props?.admin_active_vendors?.data?.length
      ? props?.admin_active_vendors?.data.map((ele) => {
        let status = getBusinessTimingsStatus(ele);
        return {
          bid: ele?._id.substr(ele?._id.length - 15),
          bname: ele?.restaurant_name,
          statusonline: statuses[status.value]?.title,
          contact: `${ele?.point_of_contact.length &&
            (ele?.point_of_contact[0]?.firstName || " ") +
            " " +
            (ele?.point_of_contact[0]?.lastName || "")
            }`,
          pocnumber: `${ele?.contact_detail[0]?.mobile_no?.country_code ||
            " " + ele?.contact_detail[0]?.mobile_no ||
            " "
            }`,
          pocemail: `${ele?.enquiry_email[0] || ""}`,
          address: `${ele?.city || ""} \n ${ele?.area} \n ${ele?.pinCode}`,
          restype:
            ele?.primary_restaurant_type.length !== 0
              ? ele?.primary_restaurant_type[0].title
              : "" || "",
          updatedAt: `${moment(new Date(ele?.updatedAt)).format(
            "DD-MM-YYYY HH:MM A"
          )}`,
        };
      })
      : [],
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Session Settings Management
                </div>
              </div>
              <div className="row">
                <div className="col-4 d-flex align-items-start">
                  <Image
                    onClick={() =>
                      setState({
                        ...state,
                        showSearch: !state.showSearch,
                      })
                    }
                    alt="filter"
                    title="filter"
                    width="80px"
                    src={require("../../../../../assets/images/iconButton/newsearchicon.svg")}
                  />
                  <div
                    className="f10-400"
                    align="center"
                    onClick={handleShowFilter}
                  >
                    <img
                      src={require("../../../../../assets/images/iconButton/filterbtn.svg")}
                      width="80px"
                    />
                    <br />
                  </div>
                  <div
                    className="f10-400"
                    align="center"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                  >
                    <img
                      src={require("../../../../../assets/images/iconButton/sortbtn.svg")}
                      width="80px"
                    />
                    <br />
                    {/* Sort */}
                  </div>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                  >
                    <MenuItem disabled>Restaurant Name / User Name</MenuItem>
                    <MenuItem onClick={() => setSort("A-Z")}>A-Z</MenuItem>
                    <MenuItem onClick={() => setSort("Z-A")}>Z-A</MenuItem>
                    <MenuItem disabled>Restaurant Status</MenuItem>
                    <MenuItem onClick={() => setSort(1)}>
                      Offline - In active - Active - OOH
                    </MenuItem>
                    <MenuItem onClick={() => setSort(2)}>
                      Active - In active - Offline - OOH
                    </MenuItem>
                  </Menu>

                  <div className="f10-400" align="center">
                    <CSVDownloader
                      filename={"vendor session"}
                      headers={downloadData.headers}
                      data={downloadData.data}
                    />
                    <br />
                  </div>
                </div>
                <div className="col-8">
                  <div>
                    <div
                      className="d-flex  mt-3 mb-3"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="mr-3 d-flex">
                        {/* <SelectFilter onDateChange={onDateChangeHandler} /> */}
                      </div>
                      <RightSideCountTop
                        content={[
                          {
                            name: "Closed Restaurants",
                            value: stats?.closed,
                            backgroundColor: "#D8F3F4",
                            color: "#138B90",
                          },
                          {
                            name: "Partially Working Restaurants",
                            value: stats?.partially,
                            backgroundColor: "#FFEDE9",
                            color: "#EE3A23",
                          },
                          {
                            name: "Full Working Restaurants",
                            value: stats?.fully,
                            backgroundColor: "#EFEBFB",
                            color: "#6F32C9",
                          },
                          {
                            name: "Total No. of Restaurants",
                            value: stats?.total,
                            backgroundColor: "#D8F3F4",
                            color: "#138B90",
                          },
                        ]}
                      />
                    </div>
                  </div>
                </div>
                {/* <div className="col-3">
                  <div className="mr-3">
                  <SelectFilter onDateChange={onDateChangeHandler} /> 
                  </div>
                </div> */}
                {/* <div className="col-2"></div> */}
              </div>
              {state.showSearch && (
                <div className="mb-3">
                  <ZoomDiv>
                    <>
                      <br />
                      <Form.Control
                        type="text"
                        placeholder="Search by business name"
                        name="search"
                        onChange={onSearchChange}
                        value={state.search}
                        className="amSearch"
                        autoFocus
                      />
                    </>
                  </ZoomDiv>
                </div>
              )}
              {showFilter && (
                <div className="col-12  mt-3">
                  <div className="enWhiteBox mt-3">
                    <Form className="row justify-content-between">
                      <Col md={5}>
                        <Form.Group>
                          <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="outlined-Status">
                              Status
                            </InputLabel>
                            <Select
                              value={state?.statusFilter}
                              onChange={(e) =>
                                setState({
                                  ...state,
                                  statusFilter: e.target.value,
                                })
                              }
                              label="Status"
                              inputProps={{
                                name: "status",
                                id: "outlined-Status",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              <MenuItem value={""}>All</MenuItem>
                              {statuses.map((data, index) => {
                                return (
                                  <MenuItem value={data.value} key={index}>
                                    {data.title}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Form.Group>
                      </Col>
                      <Col>
                        <div className="d-flex align-items-center">
                          <Button
                            variant="outline-secondary"
                            className="btn-lg mr-4 px-5"
                            onClick={cancelClick}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="danger"
                            className="btn-lg px-5"
                            onClick={searchClick}
                          >
                            Search
                          </Button>
                        </div>
                      </Col>
                    </Form>
                  </div>
                </div>
              )}

              {/* <hr /> */}

              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                {/* <div className="col-12 p-0 user-table-reusable-superadmin table-responsive"> */}
                <Table className="">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <td style={{ width: "20%" }} className="f12-400">
                        Business Name <br />
                        /Location/ID
                      </td>
                      <td style={{ width: "15%" }} className="f12-400">
                        City
                      </td>
                      <td style={{ width: "20%" }} className="f12-400">
                        Session Settings
                      </td>
                      <td style={{ width: "30%" }} className="f12-400">
                        Hours of Operation
                      </td>
                      <td style={{ width: "15%" }} className="f12-400">
                        Type of Establishment
                      </td>
                    </tr>
                  </thead>
                  <RenderTableBody
                    admin_active_vendors={props?.admin_active_vendors}
                    setStat={(e) => setStat(e)}
                    pagination={pagination}
                    state={state}
                    sort={sort}
                  />
                </Table>
              </div>
              {/* {finalData && ( */}
              <BasicPagination
                totalRecords={stats?.total || 0}
                limit={10}
                batch={pagination?.page}
                onBatchChange={(e) => handleBatchChange(e)}
              />
              {/* )} */}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const TableBody = (props) => {
  let indi_time = [];
  let timings = isInOperationalHours(props?.data, (data) => {
    indi_time = data;
  });

  return (
    <React.Fragment>
      <tbody className="w-100 super-admin-all-vendor-main-table-body">
        <tr className="w-100 p-0">
          <td className="p-0 w-100">
            <table className="w-100">
              <tbody className="sd_body_css text-break">
                <tr
                  style={{
                    border: "none",
                    borderRadius: "5px 0px 0px 5px",
                    borderLeft:
                      props?.data?.statusOnline !== "" &&
                        statuses[props?.data?.statusOnline]?.hexCode
                        ? `1.0708vw solid ${statuses[props?.data?.statusOnline]?.hexCode
                        }`
                        : "0vw solid transparent",
                  }}
                  className="sd_body_table-row p-0"
                >
                  <td
                    style={{ width: "2%" }}
                    className="table-body-left-vertical-badge-td"
                  >
                    {props?.data?.statusOnline !== "" &&
                      statuses[props?.data?.statusOnline]?.hexCode ? (
                      <div className="f9-500" style={{ letterSpacing: 1 }}>
                        {statuses[
                          props?.data?.statusOnline
                        ]?.title?.toUpperCase()}
                      </div>
                    ) : null}
                  </td>
                  <td style={{ width: "20%" }}>
                    <div className="text-break">
                      <h5 className="font_16_m mt-3">
                        {props?.data?.restaurant_name || ""}
                      </h5>
                      <p className="f10-400 mt-3"> {props?.data?.area}</p>
                      <p className="f10-400 mt-3">
                        {" "}
                        #{props?.data?._id.substr(props?.data?._id.length - 15)}
                      </p>
                    </div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="text-break">
                      <p className="f12-500 mt-3"> {props?.data?.city}</p>
                    </div>
                  </td>
                  <td style={{ width: "20%" }}>
                    <SessionSettingsAdminReports data={props?.data} />
                  </td>

                  <td style={{ width: "30%" }}>
                    <div className="f12-500">
                      {props?.data?.are_you_open_24_x_7 ? (
                        "All day"
                      ) : (
                        <>
                          {indi_time?.timings?.length &&
                            indi_time?.timings.map((d) => {
                              return (
                                <>
                                  {d}
                                  <br />
                                </>
                              );
                            })}
                          <div style={{ color: "#2196F3" }}>
                            {timings
                              ? `${"Closes: " + indi_time?.closesAt || "N/A"}`
                              : `${"Opens: " + indi_time?.opensAt || "N/A"}`}
                          </div>
                        </>
                      )}
                    </div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="f12-500">
                      {props?.data?.primary_restaurant_type?.length
                        ? props?.data?.primary_restaurant_type[0].title
                        : ""}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </React.Fragment>
  );
};

const RenderTableBody = (props) => {
  const [filtereddata, setfiltereddata] = useState([]);
  useEffect(() => {
    setfiltereddata(props?.admin_active_vendors?.data);
  }, [props?.admin_active_vendors?.data]);

  const [adminAllActiveDiners, setadminAllActiveDiners] = useState([]);
  useEffect(() => {
    setadminAllActiveDiners(props?.admin_active_vendors?.data);
  }, [props?.admin_active_vendors?.data]);

  useEffect(() => {
    if (props?.sort === "A-Z") {
      setfiltereddata(
        adminAllActiveDiners.sort((a, b) => {
          if (a.restaurant_name < b.restaurant_name) return -1;
          if (a.restaurant_name > b.restaurant_name) return 1;
          return 0;
        })
      );
    } else if (props?.sort === "Z-A") {
      setfiltereddata(
        adminAllActiveDiners.sort((a, b) => {
          if (a.restaurant_name < b.restaurant_name) return 1;
          if (a.restaurant_name > b.restaurant_name) return -1;
          return 0;
        })
      );
    } else if (props?.sort === 1) {
      setfiltereddata(
        adminAllActiveDiners.sort((a, b) => {
          return a.statusSort - b.statusSort;
        })
      );
    } else if (props?.sort === 2) {
      setfiltereddata(
        adminAllActiveDiners.sort((a, b) => {
          return a.sortValue2 - b.sortValue2;
        })
      );
    } else {
      setfiltereddata(adminAllActiveDiners);
    }
  }, [props?.sort]);

  useEffect(() => {
    setfiltereddata(
      adminAllActiveDiners?.length &&
      adminAllActiveDiners.filter((item) => {
        return (
          (((item && item._id && item._id.includes(props?.state?.search)) ||
            (item &&
              item.restaurant_name &&
              item.restaurant_name
                .toLowerCase()
                .includes(props?.state?.search.toLowerCase())) ||
            (item &&
              item.point_of_contact &&
              item.point_of_contact[0] &&
              item.point_of_contact[0]?.enquiry_emails &&
              item.point_of_contact[0]?.enquiry_emails[0] &&
              item.point_of_contact[0]?.enquiry_emails[0]
                .toLowerCase()
                .includes(props?.state?.search)) ||
            (item &&
              item.point_of_contact &&
              item.point_of_contact[0] &&
              item.point_of_contact[0]?.phone_numbers &&
              item.point_of_contact[0]?.phone_numbers[0] &&
              item.point_of_contact[0]?.phone_numbers[0].mobile_no
                .toLowerCase()
                .includes(props?.state?.search))) &&
            ((item && props?.state?.locationSearch === "" && item) ||
              (item &&
                props?.state?.locationSearch !== "" &&
                item.city &&
                item.city
                  .toLowerCase()
                  .includes(props?.state?.locationSearch.toLowerCase())))) ||
          item?.vendor?.referral_code
            ?.toLowerCase()
            ?.includes(props?.state?.search?.toLowerCase())
        );
      })
    );
  }, [props?.state]);
  useEffect(() => {
    setfiltereddata(
      adminAllActiveDiners &&
      adminAllActiveDiners.filter((item, index) => {
        let status = getBusinessTimingsStatus(item);
        adminAllActiveDiners[index].statusOnline = status.value;
        adminAllActiveDiners[index].statusSort = status.sortValue;
        adminAllActiveDiners[index].sortValue2 = status.sortValue2;
        if (props?.state?.statusFilter !== "") {
          return status.value === props?.state?.statusFilter;
        }
        return true;
      })
    );
  }, [props?.state]);

  let localStat = {
    closed: 0,
    partially: 0,
    fully: 0,
    total: 0,
  };
  if (filtereddata?.length) {
    localStat.fully = filtereddata.filter((item) => {
      let status = getBusinessTimingsStatus(item);
      if (status.value === 0) return true;
      else return false;
    }).length;
    localStat.partially = filtereddata.filter((item) => {
      let status = getBusinessTimingsStatus(item);
      if (status.value === 1) return true;
      else return false;
    }).length;
    localStat.closed = filtereddata.filter((item) => {
      let status = getBusinessTimingsStatus(item);
      if (status.value === 2) return true;
      else return false;
    }).length;
  }
  useEffect(() => {
    props.setStat({ ...localStat, total: filtereddata?.length });
  }, [filtereddata?.length]);

  return (
    <React.Fragment>
      {filtereddata?.length
        ? filtereddata
          .filter((item) => {
            let status = getBusinessTimingsStatus(item);
            item.statusOnline = status.value;
            item.statusSort = status.sortValue;
            item.sortValue2 = status.sortValue2;
            if (props?.state?.search) {
              return (
                item?._id?.includes(props?.state?.search) ||
                item?.restaurant_name
                  ?.toLowerCase()
                  ?.includes(props?.state?.search.toLowerCase()) ||
                (item?.point_of_contact?.length &&
                  item?.point_of_contact[0]?.enquiry_emails?.length &&
                  item?.point_of_contact[0]?.enquiry_emails[0]
                    ?.toLowerCase()
                    ?.includes(props?.state?.search)) ||
                (item?.point_of_contact[0]?.length &&
                  item?.point_of_contact[0]?.phone_numbers?.length &&
                  item?.point_of_contact[0]?.phone_numbers[0]?.mobile_no
                    ?.toLowerCase()
                    ?.includes(props?.state?.search)) ||
                item?.restaurant_address
                  ?.toLowerCase()
                  ?.includes(props?.state?.search.toLowerCase())
              );
            } else return item;
          })
          .slice(props?.pagination?.start, props?.pagination?.end)
          .map((data, index) => {

            return <TableBody key={index} data={data} />;
          })
        : <NoContent />}
    </React.Fragment>
  );
};
SuperAdminPromotionalVideos.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  admin_active_vendors: state.adminAllVendorsInfo.superAdminAllActiveVendors,
});

export default connect(mapStateToProps, { get_all_admin_active_vendors })(
  withRouter(SuperAdminPromotionalVideos)
);
